import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { styled, Accordion, AccordionSummary, AccordionDetails, useMediaQuery, Typography } from '@mui/material'
import { Add, Remove } from '@mui/icons-material'
import Masonry from 'react-masonry-css'
import RTGLogo from '@shared/svgs/logo'
import ApplyButton, { isSynchronyApplyLink, isSynchronyWithQueriesLink } from '@shared/apply-button'
import StrapiLink from '@templates/strapi-cms/content-types/Link'
import { useModalsContext } from '@context/modalContext'
import { useFirebaseContext } from '@context/firebaseContext'
import { useTest } from '@hooks/useTest'
import EmailSubscribeForm from './email-subscribe-form'
import Ratings from '../../@rtg2022/components/atoms/Ratings/Ratings'
import StrapiImage from '../../templates/strapi-cms/content-types/Image'
import '../../assets/css/global/footer.scss'

const AppStore = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 150 45"
    role="img"
    aria-labelledby="appledownloadId appledownloadDesc"
    {...props}
  >
    <title id="appledownloadId">Download on the App Store</title>
    <desc id="appledownloadDesc">Rooms To Go in Apple iOS App Store</desc>
    <path
      fill="#fff"
      d="M66.49 26.38c-.52 0-.99.12-1.41.36s-.75.59-.99 1.03c-.24.45-.37.96-.37 1.55s.12 1.1.37 1.55c.24.45.57.79.99 1.03s.89.36 1.41.36c.81 0 1.46-.26 1.98-.8.52-.55.78-1.26.78-2.14s-.26-1.59-.78-2.13c-.52-.54-1.18-.81-1.98-.81ZM78.43 26.38c-.52 0-.99.12-1.41.36s-.75.59-.99 1.03c-.24.45-.37.96-.37 1.55s.12 1.1.37 1.55.57.79.99 1.03.89.36 1.41.36c.8 0 1.46-.26 1.98-.8.52-.55.78-1.26.78-2.14s-.26-1.59-.78-2.13c-.52-.54-1.18-.81-1.98-.81ZM90.76 14.52h-.01c.31-.21.54-.5.7-.89v-1.01h-1.82c-.52 0-.9.09-1.14.29-.24.19-.35.46-.35.79 0 .35.13.63.39.83.25.2.62.3 1.09.3s.83-.1 1.14-.31ZM85 10.52c-.32-.19-.69-.29-1.09-.29s-.77.09-1.09.29-.58.46-.76.81c-.19.35-.28.74-.28 1.18s.09.83.28 1.18c.19.35.44.61.76.81.32.19.69.29 1.09.29s.77-.09 1.09-.29c.32-.2.58-.46.76-.81.19-.35.28-.74.28-1.18s-.09-.83-.28-1.18a2.12 2.12 0 0 0-.76-.81ZM51.35 29.36h4.57l-2.29-5.39-2.28 5.39zM95.06 14.51c.32.19.69.29 1.09.29s.77-.09 1.09-.29c.32-.2.58-.46.76-.81.19-.35.28-.74.28-1.18s-.09-.83-.28-1.18a2.12 2.12 0 0 0-.76-.81c-.32-.19-.69-.29-1.09-.29s-.77.09-1.09.29c-.32.19-.58.46-.76.81-.19.35-.28.74-.28 1.18s.09.83.28 1.18c.19.35.44.61.76.81ZM133.95 11.22c-.18-.3-.42-.54-.72-.71-.3-.17-.63-.26-1.01-.26s-.72.08-1.01.25h.01c-.3.17-.54.4-.72.71s-.29.65-.31 1.04h4.07a2.11 2.11 0 0 0-.31-1.03ZM53.65 14.34c.5-.26.89-.64 1.16-1.11.27-.47.41-1.02.41-1.63s-.14-1.15-.41-1.63c-.27-.47-.66-.84-1.16-1.11-.5-.26-1.08-.4-1.74-.4h-2.26v6.27h2.26c.66.01 1.24-.12 1.74-.39ZM60.56 10.52c-.32-.19-.69-.29-1.09-.29s-.77.09-1.09.29-.58.46-.76.81c-.19.35-.28.74-.28 1.18s.09.83.28 1.18c.19.35.44.61.76.81.32.19.69.29 1.09.29s.77-.09 1.09-.29c.32-.2.58-.46.76-.81.19-.35.28-.74.28-1.18s-.09-.83-.28-1.18a2.12 2.12 0 0 0-.76-.81ZM107.49 11.33a2.12 2.12 0 0 0-.76-.81c-.32-.19-.69-.29-1.09-.29s-.77.09-1.09.29c-.32.2-.58.46-.76.81-.19.35-.28.74-.28 1.18s.09.83.28 1.18c.19.35.44.61.76.81.32.19.69.29 1.09.29s.78-.09 1.09-.29c.32-.2.58-.46.76-.81.19-.35.28-.74.28-1.18s-.09-.83-.28-1.18ZM130.69 26.26c-.7 0-1.29.21-1.77.62-.48.42-.78.97-.88 1.67h5.27c-.09-.68-.38-1.23-.85-1.65-.48-.42-1.07-.64-1.77-.64Z"
    />
    <path
      fill="#fff"
      d="M144.2 0H5.8C2.6 0 0 2.56 0 5.72v33.56C0 42.44 2.6 45 5.8 45h138.4c3.2 0 5.8-2.56 5.8-5.71V5.72c0-3.16-2.6-5.72-5.8-5.72Zm-14.18 11.12c.22-.42.52-.74.91-.98.39-.23.82-.35 1.31-.35s.91.11 1.3.35c.38.23.68.55.91.96.22.42.33.88.33 1.4l-.02.14h-.01l-4.57.01c.01.42.12.79.32 1.12.2.33.47.58.8.75.34.18.72.27 1.14.27.35 0 .67-.06.96-.19.3-.13.54-.31.74-.56l.3.34c-.23.28-.52.5-.87.65-.35.15-.73.23-1.14.23-.53 0-1-.12-1.42-.35s-.74-.55-.97-.97c-.24-.42-.35-.88-.35-1.41s.11-.99.33-1.41Zm-6.63-3.55h.51v3.39c.18-.37.45-.66.81-.86s.78-.3 1.28-.3c.68 0 1.2.19 1.58.59.39.38.58.95.58 1.68v3.15h-.51v-3.11c0-.6-.15-1.06-.45-1.38-.31-.31-.73-.47-1.27-.47-.62 0-1.12.19-1.48.57-.36.38-.54.89-.54 1.52v2.86h-.51V7.57Zm-13.52 2.26h.49v1.16c.18-.38.45-.67.82-.89.36-.21.79-.32 1.29-.32.67 0 1.2.2 1.59.59h-.01c.39.4.58.97.58 1.7v3.15h-.51v-3.11c0-.6-.15-1.06-.45-1.38-.3-.31-.73-.47-1.27-.47-.62 0-1.12.19-1.48.57-.36.38-.54.89-.54 1.52v2.86h-.51V9.83Zm-16.04 1.28c.23-.42.54-.74.95-.97.4-.23.85-.35 1.34-.35a2.38 2.38 0 0 1 2.17 1.29V7.56h.5v7.65h-.5v-1.26c-.21.42-.5.74-.88.97-.38.23-.81.34-1.29.34s-.94-.12-1.34-.35c-.4-.23-.72-.55-.95-.97-.23-.42-.34-.88-.34-1.41s.11-1 .34-1.42ZM79.17 7.57h.51v7.64h-.51V7.57ZM63.06 9.83l1.77 4.8 1.82-4.8h.44l1.8 4.79 1.79-4.79h.45l-2.01 5.38h-.48l-1.79-4.67-1.8 4.67h-.47l-2.01-5.38h.49ZM49.13 8h2.82c.74 0 1.4.16 1.97.47.57.31 1.02.74 1.34 1.28.32.55.48 1.16.48 1.86s-.16 1.31-.48 1.86-.76.97-1.34 1.28c-.57.31-1.23.47-1.97.47h-2.82V8Zm-21.45 2.37c1.07-1.26 2.85-2.19 4.34-2.25.12-.01.23.08.24.21.18 1.59-.39 3.37-1.52 4.75-1.08 1.32-2.65 2.13-4.1 2.13-.09 0-.2-.01-.3-.01-.11-.02-.21-.1-.22-.21-.23-1.79.65-3.56 1.56-4.62Zm10.44 19.12c-.2.66-.79 2.35-1.98 4.11-1.13 1.68-2.42 3.58-4.52 3.62-.98.02-1.64-.27-2.29-.55-.66-.29-1.28-.59-2.39-.59s-1.83.3-2.51.6c-.62.26-1.24.53-2.12.57h-.11c-1.86 0-3.22-1.77-4.56-3.73-2.69-3.93-4.23-10.42-1.8-14.69v.02c1.28-2.25 3.6-3.67 6.05-3.71h.07c1.05 0 2.05.4 2.93.75.66.26 1.23.49 1.67.49.39 0 .96-.22 1.61-.48.95-.38 2.13-.85 3.36-.85.16 0 .32.02.47.03 1.05.05 3.65.42 5.35 2.94.04.05.06.12.04.18s-.05.11-.11.16h-.02c-.49.3-2.95 2.01-2.92 5.23.03 3.96 3.27 5.42 3.64 5.57H38c.11.06.16.19.12.3v.03Zm19.77 4.52-1.22-2.85h-6.09l-1.2 2.85h-2.33l5.48-12.32h2.23l5.5 12.32h-2.37Zm2.93-19.11c-.4.23-.86.35-1.36.35s-.96-.12-1.36-.35c-.4-.23-.72-.56-.95-.97-.23-.42-.35-.89-.35-1.41s.12-.99.35-1.41c.23-.42.55-.74.95-.98.4-.23.86-.35 1.36-.35s.96.12 1.36.35c.4.23.72.56.95.98.23.42.35.89.35 1.41s-.12.99-.35 1.41c-.23.42-.55.74-.95.97Zm10.03 16.94c-.4.74-.96 1.3-1.68 1.7-.72.4-1.52.6-2.42.6-1.26 0-2.24-.42-2.98-1.27v4.56h-2.18V24.62h2.08v1.23c.36-.45.8-.78 1.33-1.01a4.51 4.51 0 0 1 1.75-.33c.91 0 1.72.19 2.42.59.72.4 1.27.96 1.68 1.69.4.73.61 1.57.61 2.52s-.21 1.79-.61 2.53Zm1.97-19.49v2.86h-.51V9.83h.49v1.16c.18-.38.45-.67.82-.89.36-.21.79-.32 1.29-.32.67 0 1.2.2 1.59.59h-.01c.39.4.58.97.58 1.7v3.15h-.51v-3.11c0-.6-.15-1.06-.45-1.38-.3-.31-.73-.47-1.27-.47-.62 0-1.12.19-1.48.57-.36.38-.54.89-.54 1.52Zm9.97 19.49c-.4.74-.96 1.3-1.68 1.7-.71.4-1.52.6-2.42.6-1.26 0-2.24-.42-2.98-1.27v4.56h-2.18V24.51h2.07v1.34c.36-.45.8-.78 1.33-1.01a4.51 4.51 0 0 1 1.75-.33c.91 0 1.72.2 2.43.6.72.39 1.27.95 1.68 1.68.4.73.61 1.57.61 2.52s-.21 1.79-.61 2.53Zm3.42-17.91c-.23.42-.55.74-.95.97-.4.23-.86.35-1.36.35s-.96-.12-1.36-.35c-.4-.23-.72-.56-.95-.97-.23-.42-.35-.89-.35-1.41s.12-.99.35-1.41c.23-.42.55-.74.95-.98.4-.23.86-.35 1.36-.35s.96.12 1.36.35c.4.23.72.56.95.98.23.42.35.89.35 1.41s-.12.99-.35 1.41Zm1.42-.2c0-.46.16-.81.47-1.09.32-.28.82-.42 1.51-.42h1.82v-.43c0-.5-.14-.88-.4-1.14-.27-.26-.66-.39-1.18-.39-.35 0-.69.06-1.01.18-.32.13-.6.29-.82.5l-.25-.37c.27-.24.58-.43.96-.56.37-.13.76-.2 1.17-.2.67 0 1.18.17 1.53.51.35.33.53.83.53 1.49v3.41h-.49v-.96c-.17.31-.42.56-.75.74-.32.18-.72.26-1.17.26-.59 0-1.06-.14-1.4-.42-.34-.28-.52-.65-.52-1.11Zm10.99 18.65c-.37.55-.92.99-1.66 1.32-.74.33-1.65.49-2.72.49-.93 0-1.84-.14-2.72-.41h.01c-.88-.27-1.57-.63-2.08-1.08l.78-1.78c.5.4 1.11.72 1.83.98.73.25 1.45.38 2.18.38.91 0 1.58-.14 2.03-.44s.67-.68.67-1.16c0-.35-.12-.64-.37-.87a2.5 2.5 0 0 0-.95-.53c-.39-.13-.91-.28-1.57-.44-.93-.22-1.68-.45-2.25-.67a3.66 3.66 0 0 1-1.48-1.05c-.41-.48-.62-1.12-.62-1.92 0-.68.18-1.3.55-1.86s.91-1 1.65-1.33c.73-.33 1.64-.49 2.7-.49.74 0 1.47.09 2.19.28.72.19 1.34.46 1.86.81l-.71 1.78c-.53-.31-1.09-.56-1.67-.72-.58-.16-1.14-.25-1.69-.25-.9 0-1.56.15-1.99.46-.44.31-.65.71-.65 1.21 0 .35.12.64.37.86.25.22.57.4.95.53.39.13.91.28 1.57.44.91.21 1.65.43 2.23.66.58.23 1.08.58 1.49 1.05.41.47.62 1.1.62 1.9 0 .68-.18 1.3-.55 1.85Zm8.18 1.12c-.25.21-.57.37-.93.48-.37.11-.75.16-1.16.16-1.02 0-1.81-.27-2.37-.81s-.83-1.33-.83-2.36v-4.52h-1.53v-1.76h1.53v-2.15h2.18v2.15h2.49v1.76h-2.49v4.47c0 .46.11.81.33 1.05.22.24.54.36.96.36.48 0 .9-.13 1.22-.39l.61 1.57h-.01Zm-1.16-18.26c-.5 0-.96-.12-1.36-.35-.4-.23-.72-.56-.95-.97-.23-.42-.35-.89-.35-1.41s.12-.99.35-1.41c.23-.42.55-.74.95-.98.4-.23.86-.35 1.36-.35s.96.12 1.36.35c.4.23.72.56.95.98.23.42.35.89.35 1.41s-.12.99-.35 1.41c-.23.42-.55.74-.95.97-.4.23-.86.35-1.36.35Zm11.14 16.55c-.42.74-1.01 1.31-1.76 1.72-.75.41-1.6.62-2.56.62s-1.78-.21-2.54-.62c-.75-.41-1.34-.98-1.76-1.72-.42-.74-.63-1.57-.63-2.49s.21-1.76.63-2.48c.42-.73 1.01-1.3 1.76-1.71.75-.41 1.6-.62 2.54-.62s1.8.21 2.56.62c.75.41 1.34.98 1.76 1.71.42.73.64 1.55.64 2.48s-.21 1.76-.64 2.49Zm1.68-21.53v-.44h.98V8.64h.51v1.18h1.69v.44h-1.69v3.46c0 .35.08.62.25.8s.41.27.74.27.61-.1.83-.3l.21.36c-.13.14-.29.23-.49.29-.19.06-.4.1-.6.1-.46 0-.82-.13-1.07-.38-.25-.26-.38-.62-.38-1.08v-3.52h-.98Zm6.42 16.32c-.19-.04-.35-.05-.5-.05-.85 0-1.51.25-1.98.75-.48.5-.71 1.22-.71 2.16V34h-2.18v-9.4h2.07v1.37c.63-.99 1.74-1.48 3.3-1.48h.01-.01v2.09Zm10.47 3.41h-7.29c.13.69.46 1.24 1 1.65.54.4 1.21.61 2.01.61 1.02 0 1.86-.34 2.52-1.02l1.17 1.36c-.42.5-.94.89-1.58 1.14-.64.26-1.36.39-2.16.39-1.02 0-1.92-.21-2.7-.62-.78-.41-1.38-.98-1.8-1.72s-.63-1.57-.63-2.49.21-1.74.61-2.47c.41-.74.98-1.31 1.72-1.72.73-.41 1.56-.62 2.47-.62s1.72.2 2.42.61c.72.4 1.27.98 1.67 1.71.4.74.6 1.58.6 2.54 0 .14-.01.35-.03.64Z"
    />
    <path
      fill="#fff"
      d="M112.47 26.38c-.8 0-1.46.27-1.98.81s-.78 1.25-.78 2.13.26 1.59.78 2.13c.52.54 1.17.81 1.98.81s1.46-.28 1.98-.81c.52-.54.78-1.25.78-2.13s-.26-1.59-.78-2.13c-.52-.54-1.18-.81-1.98-.81Z"
    />
  </svg>
)

const GooglePlay = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 150 45"
    role="img"
    aria-labelledby="googleandroidId googleandroidDesc"
    {...props}
  >
    <title id="googleandroidId">Available on the Google Play</title>
    <desc id="googleandroidDesc">Rooms To Go in Android App Store</desc>
    <path
      fill="#fff"
      d="M67.91 25.8c-.78 0-1.42.26-1.93.78-.5.52-.76 1.21-.76 2.06s.25 1.54.76 2.06c.5.52 1.15.78 1.93.78s1.43-.26 1.94-.78.76-1.21.76-2.06-.25-1.54-.76-2.06-1.16-.78-1.94-.78ZM56.93 25.8c-.78 0-1.42.26-1.93.78-.5.52-.76 1.21-.76 2.06s.25 1.54.76 2.06c.5.52 1.15.78 1.93.78s1.43-.26 1.94-.78.76-1.21.76-2.06-.25-1.54-.76-2.06-1.16-.78-1.94-.78ZM111.79 23.16h-2.59v4.73h2.59c.96 0 1.7-.2 2.19-.61.5-.42.75-1.01.75-1.76s-.25-1.34-.75-1.75c-.5-.41-1.23-.61-2.19-.61ZM95.46 25.71c-.68 0-1.26.19-1.73.6-.47.4-.76.94-.86 1.61h5.15c-.09-.66-.37-1.19-.83-1.6-.47-.41-1.04-.61-1.73-.61ZM92.46 13.1c.18-.35.28-.73.28-1.16s-.09-.82-.28-1.16-.44-.6-.76-.8c-.32-.2-.69-.29-1.09-.29s-.77.09-1.09.29c-.32.2-.58.45-.76.8-.19.34-.28.73-.28 1.16s.09.82.28 1.16c.19.34.44.6.76.8.32.2.69.29 1.09.29s.77-.09 1.09-.29c.32-.19.58-.45.76-.8ZM78.96 25.81c-.8 0-1.48.24-2 .72s-.77 1.1-.77 1.85.25 1.4.77 1.88c.52.49 1.18.72 2 .72s1.47-.24 1.98-.72c.52-.48.77-1.11.77-1.88s-.26-1.38-.77-1.85c-.52-.48-1.18-.72-1.98-.72ZM74.82 13.11c.19-.34.28-.73.28-1.16s-.09-.82-.28-1.16c-.19-.34-.44-.6-.77-.8-.32-.19-.69-.29-1.1-.29s-.77.09-1.09.29c-.32.19-.58.45-.76.8-.19.34-.28.73-.28 1.16s.09.82.28 1.16c.19.34.44.6.76.8.32.19.69.29 1.09.29s.78-.09 1.1-.29c.32-.19.58-.45.77-.8ZM118.93 10.66c-.18-.3-.42-.54-.72-.7-.3-.17-.63-.26-1.01-.26s-.71.08-1.01.25h-.01c-.3.17-.54.4-.71.7-.18.3-.29.64-.31 1.03h4.07c-.02-.38-.12-.72-.3-1.02ZM53.48 12.33c-.24.19-.35.45-.35.78 0 .35.13.62.39.82.25.2.62.3 1.09.3s.83-.1 1.14-.3h-.01c.31-.22.54-.51.7-.89v-1h-1.82c-.52 0-.9.09-1.14.29ZM64.73 12.33c-.24.19-.35.45-.35.78 0 .35.13.62.39.82.25.2.62.3 1.09.3s.83-.1 1.14-.3h-.01c.31-.22.54-.51.7-.89v-1h-1.82c-.52 0-.9.09-1.14.29ZM125.51 30.49c0 .39.16.69.46.92.31.23.73.34 1.28.34s1-.12 1.42-.37h-.01c.42-.23.71-.58.88-1.04v-1.06h-2.19c-1.23 0-1.84.4-1.84 1.21ZM45.36 12.16l-1.88-4.12-1.87 4.12h3.75z"
    />
    <path
      fill="#fff"
      d="M144.2 0H5.8C2.6 0 0 2.56 0 5.73v33.54C0 42.43 2.6 45 5.8 45h138.4c3.2 0 5.8-2.56 5.8-5.72V5.73c0-3.16-2.6-5.73-5.8-5.73Zm-35.84 7.05h.51v3.35c.18-.37.45-.65.81-.85.36-.2.78-.3 1.28-.3.67 0 1.2.19 1.58.58.39.39.58.95.58 1.67v3.11h-.51v-3.07c0-.6-.15-1.05-.45-1.36s-.73-.47-1.27-.47c-.62 0-1.12.19-1.48.56-.36.37-.54.88-.54 1.51v2.83h-.51V7.05ZM94.83 9.29h.49v1.15c.18-.37.45-.67.82-.88.36-.21.79-.32 1.29-.32.67 0 1.2.2 1.59.58.39.4.58.96.58 1.68v3.11h-.51v-3.07c0-.6-.15-1.05-.45-1.36s-.73-.47-1.27-.47c-.62 0-1.12.19-1.48.56s-.54.88-.54 1.51v2.83h-.51V9.29ZM77.17 7.05h.51v7.56h-.51V7.05Zm-9.9 3.02c-.27-.26-.66-.39-1.18-.39-.35 0-.69.06-1.01.18-.32.12-.6.29-.82.49l-.25-.37c.27-.24.58-.42.96-.55.37-.13.76-.2 1.17-.2.67 0 1.18.17 1.53.5v.02c.35.34.53.83.53 1.48v3.37h-.49v-.95c-.17.31-.42.55-.75.73-.32.17-.72.26-1.17.26-.59 0-1.06-.14-1.4-.42-.34-.28-.52-.65-.52-1.1s.16-.8.47-1.08c.32-.27.82-.41 1.51-.41h1.82v-.43c0-.5-.14-.87-.4-1.13ZM59 7.28c.08-.08.18-.12.3-.12s.21.04.3.12c.08.08.12.17.12.29s-.04.21-.12.3c-.08.08-.18.12-.3.12s-.22-.04-.3-.12c-.08-.08-.12-.17-.12-.29s.04-.21.12-.3Zm.55 2v5.32h-.51V9.28h.51Zm-3.53.79c-.27-.26-.66-.39-1.18-.39-.35 0-.69.06-1.01.18-.32.12-.6.29-.82.49l-.25-.37c.27-.24.58-.42.96-.55.37-.13.76-.2 1.17-.2.67 0 1.18.17 1.53.5v.02c.35.34.53.83.53 1.48v3.37h-.49v-.95c-.17.31-.42.55-.75.73-.32.17-.71.26-1.17.26-.59 0-1.06-.14-1.4-.42-.34-.28-.52-.65-.52-1.1s.16-.8.47-1.08c.32-.27.82-.41 1.51-.41h1.82v-.43c0-.5-.14-.87-.4-1.13Zm-8.64-.78 2.12 4.76 2.14-4.76h.52l-2.41 5.32h-.52l-2.39-5.32h.54Zm-4.15-1.82h.52l3.28 7.14h-.56l-.91-2.01h-4.14l-.91 2.01h-.56l3.28-7.14Zm-21.21 6.81 6.29 3.63-4.5 4.36L8.24 7.21l13.78 7.07ZM7.33 7.82l15.71 15.2L7.31 38.23l.02-30.41Zm14.72 23.3L8.47 38.61l15.34-14.83 4.1 3.96-5.86 3.38Zm12.96-7.48-6.12 3.53-4.3-4.16 4.7-4.54 5.71 3.3h.01c.33.2.54.55.54.94s-.2.74-.54.93Zm6.86 5.76c.37.63.88 1.13 1.53 1.5.65.36 1.39.55 2.22.55.93 0 1.75-.21 2.45-.61v-3.72l2.09-.01v4.75c-.61.49-1.32.86-2.15 1.13-.81.26-1.65.39-2.52.39-1.21 0-2.31-.26-3.28-.79-.98-.53-1.74-1.26-2.29-2.19s-.83-1.98-.83-3.15.28-2.22.83-3.15 1.32-1.66 2.31-2.19c.98-.53 2.08-.79 3.31-.79.99 0 1.9.16 2.72.49.81.33 1.5.81 2.06 1.45l-1.4 1.36c-.91-.91-2-1.36-3.28-1.36-.84 0-1.59.17-2.24.53-.65.35-1.16.85-1.53 1.48s-.55 1.36-.55 2.18.19 1.51.55 2.15Zm19.3 1.66c-.42.71-.99 1.26-1.73 1.66s-1.57.6-2.5.6-1.74-.2-2.48-.6c-.74-.4-1.31-.95-1.73-1.66-.42-.71-.62-1.51-.62-2.41s.21-1.7.62-2.4c.42-.7.99-1.25 1.73-1.65.74-.4 1.57-.6 2.48-.6s1.77.2 2.5.6c.74.4 1.31.95 1.73 1.65.42.7.62 1.51.62 2.4s-.21 1.7-.62 2.41Zm1.05-16.45h-.51V7.05h.51v7.56Zm9.93 16.45c-.42.71-.99 1.26-1.73 1.66-.74.4-1.57.6-2.5.6s-1.75-.2-2.48-.6c-.74-.4-1.31-.95-1.73-1.66-.42-.71-.62-1.51-.62-2.41s.21-1.7.62-2.4c.42-.7.99-1.25 1.73-1.65.74-.4 1.57-.6 2.48-.6s1.77.2 2.5.6c.74.4 1.31.95 1.73 1.65.42.7.62 1.51.62 2.4s-.21 1.7-.62 2.41Zm-.46-16.75c-.39-.23-.68-.55-.89-.95v1.25h-.49V7.05h.51v3.45c.21-.39.5-.7.88-.92.38-.22.8-.33 1.27-.33.5 0 .94.11 1.34.34h.01c.4.23.71.55.94.96.23.41.34.88.34 1.4s-.11.99-.34 1.39c-.23.41-.54.73-.94.96-.4.23-.85.35-1.34.35s-.91-.11-1.29-.34Zm12.13 9.8v7.71c0 3.2-1.64 4.8-4.9 4.8-.87 0-1.7-.11-2.48-.33-.78-.22-1.43-.54-1.94-.96l.95-1.6c.4.33.9.59 1.5.79.61.2 1.22.3 1.85.3.99 0 1.73-.23 2.19-.68.47-.45.7-1.14.7-2.08v-.48c-.36.4-.8.7-1.32.9-.52.21-1.09.3-1.72.3-.86 0-1.64-.19-2.34-.55-.7-.37-1.25-.89-1.65-1.56-.4-.67-.6-1.44-.6-2.3s.2-1.62.6-2.29c.4-.67.95-1.18 1.65-1.54s1.48-.55 2.34-.55c.66 0 1.26.11 1.8.32.54.22.99.55 1.35.99v-1.21h2.02v.02Zm.52-12.03h-.01l-4.57-.01c.01.42.12.78.32 1.11.2.32.47.57.8.75.34.17.71.27 1.14.27.35 0 .67-.06.96-.19.3-.12.54-.31.74-.55l.3.34c-.23.28-.52.49-.87.64-.35.15-.73.22-1.14.22-.53 0-1-.12-1.42-.35-.42-.23-.74-.55-.97-.96-.24-.41-.35-.87-.35-1.39s.11-.98.33-1.39c.22-.41.52-.73.91-.96.39-.23.82-.35 1.31-.35s.91.11 1.3.34.68.55.91.95c.22.41.33.87.33 1.39l-.02.14Zm4.4 21.12h-2.13V20.57h2.13V33.2Zm.51-18.9c-.4-.23-.72-.55-.95-.96s-.35-.88-.35-1.39.12-.98.35-1.39c.23-.41.55-.73.95-.96s.86-.35 1.36-.35.96.12 1.36.35c.4.23.72.55.95.96.23.41.35.88.35 1.39s-.12.98-.35 1.39-.55.73-.95.96c-.4.23-.86.35-1.36.35s-.96-.12-1.36-.35Zm10.77 15.03h-7.13c.12.67.45 1.2.98 1.59.53.39 1.18.58 1.96.58.99 0 1.82-.33 2.47-.99l1.14 1.31c-.41.49-.93.86-1.55 1.11s-1.32.37-2.11.37c-.99 0-1.88-.2-2.64-.6-.76-.4-1.35-.95-1.76-1.66-.42-.71-.62-1.51-.62-2.41s.2-1.68.6-2.39c.4-.71.96-1.26 1.67-1.66.71-.4 1.52-.6 2.41-.6s1.67.19 2.38.58c.7.39 1.24.94 1.63 1.65.39.71.58 1.53.58 2.46 0 .16 0 .37-.03.64l.02.02Zm6.45-14.78c-.19.06-.4.1-.6.1-.46 0-.82-.12-1.07-.38s-.38-.61-.38-1.06V9.73h-.98v-.44h.98V8.13h.51v1.16h1.69v.44h-1.69v3.42c0 .35.08.61.25.79.17.18.41.27.74.27s.61-.1.83-.3l.21.36c-.13.12-.29.22-.49.28Zm9.88 13.21c-.41.64-1 1.13-1.76 1.47-.76.34-1.67.51-2.7.51h-2.69v3.44h-2.21V21.26h4.9c1.04 0 1.93.17 2.7.51v.02c.76.34 1.35.83 1.76 1.46.41.63.61 1.39.61 2.26s-.21 1.61-.61 2.25Zm1.06-13.1c-.53 0-1-.12-1.42-.35-.42-.23-.74-.55-.97-.96-.24-.41-.35-.87-.35-1.39s.11-.98.33-1.39c.22-.41.52-.73.91-.96.39-.23.82-.35 1.31-.35s.91.11 1.3.34.68.55.91.95c.22.41.33.87.33 1.39l-.03.14-4.57-.01c.01.42.12.78.32 1.11.2.32.47.57.8.75.34.17.72.27 1.14.27.35 0 .67-.06.96-.19.3-.12.54-.31.74-.55l.3.34c-.23.28-.52.49-.87.64-.35.15-.73.22-1.14.22Zm3.86 18.54h-2.13V20.57h2.13V33.2Zm10.38 0h-2.01v-1.11c-.26.4-.63.7-1.11.91-.49.21-1.06.32-1.74.32s-1.27-.12-1.78-.35-.9-.55-1.18-.97c-.28-.42-.42-.88-.42-1.41 0-.82.31-1.47.91-1.97.61-.49 1.56-.74 2.87-.74h2.35v-.14c0-.63-.19-1.13-.57-1.46-.38-.34-.95-.51-1.69-.51-.51 0-1.01.08-1.5.24-.49.16-.91.38-1.25.67l-.83-1.55c.48-.36 1.05-.64 1.72-.83s1.38-.29 2.13-.29c1.34 0 2.36.33 3.07.97h-.03c.71.63 1.06 1.6 1.06 2.89v5.33Zm6.81.73c-.4.99-.88 1.68-1.45 2.08-.57.4-1.26.6-2.06.6-.45 0-.9-.07-1.34-.22-.44-.15-.8-.35-1.09-.61l.85-1.57c.21.19.45.35.72.46.28.11.56.17.84.17.37 0 .68-.1.93-.29.24-.19.47-.52.67-.97l.15-.35-3.96-9.12h2.21l2.86 6.73 2.87-6.73h2.05l-4.25 9.82Z"
    />
    <path
      fill="#fff"
      d="M82.83 9.96c-.3-.17-.63-.26-1.01-.26s-.72.08-1.01.25h-.01c-.3.17-.54.4-.71.7-.18.3-.29.64-.31 1.03h4.07c-.02-.38-.12-.72-.3-1.02s-.42-.54-.72-.7Z"
    />
  </svg>
)

const MobileStoreDownloads = () => (
  <div className="footer__store-downloads">
    <span className="footer__store-downloads__title">RTG Mobile App</span>
    <div className="footer__store-downloads__stores">
      <StrapiLink
        className="footer__store-downloads__store-icon"
        data={{
          ExternalUrl: 'https://apps.apple.com/us/app/room-to-go/id898852501',
          displayText: 'Get the Rooms To Go App',
          id: 'rtg-app-ios',
        }}
        trackingData={{
          category: 'footer',
          action: 'click',
          label: 'RTG iOS app download',
        }}
      >
        <AppStore />
      </StrapiLink>
      <StrapiLink
        className="footer__store-downloads__store-icon"
        data={{
          ExternalUrl: 'https://play.google.com/store/apps/details?id=com.roomstogo.dealstogo',
          displayText: 'Get the Rooms To Go App',
          id: 'rtg-app-android',
        }}
        trackingData={{
          category: 'footer',
          action: 'click',
          label: 'RTG Android app download',
        }}
      >
        <GooglePlay />
      </StrapiLink>
    </div>
  </div>
)

const TopRatedRetailer = () => (
  <div className="footer__top-rated-retailer">
    <StrapiImage
      data={{
        desktop: { url: 'https://rtg-contentful.s3.amazonaws.com/images/Badge_Top_Retailers.png' },
        alt: 'Top Rated Retailer',
      }}
    />
    <div>
      <span className="title">ROOMS TO GO</span>
      <span className="subtitle">Top Rated Retailer</span>
      <Ratings name="half-rating-read" readOnly max={5} precision={0.2} value={5} />
    </div>
  </div>
)

const SocialMedia = () => (
  <div className="footer__social-media">
    <span className="footer__social-media__title">Follow Us</span>
    <span className="footer__social-media__description">Follow Rooms To Go on social media</span>
    <div className="footer__social-media__links">
      <StrapiLink
        target="_blank"
        rel="noopener"
        className="icon"
        data={{
          ExternalUrl: 'https://www.facebook.com/roomstogo/',
          id: 'facebook-icon',
        }}
        trackingData={{
          category: 'footer',
          action: 'social click',
          label: 'facebook',
        }}
      >
        <img
          className="fb"
          alt="Facebook (opens in new window)"
          src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2023.94%2051.86%22%20fill%3D%22%23FFFFFF%22%3E%3Cg%20id%3D%22Layer%5f2%22%20data-name%3D%22Layer%202%22%3E%3Cg%20id%3D%22Objects%22%3E%3Cpath%20d%3D%22M5.43%2C51.86H15.87V25.71h7.29L23.94%2C17H15.87V12c0-2.07.42-2.88%2C2.41-2.88h5.66V0H16.71C8.93%2C0%2C5.43%2C3.42%2C5.43%2C10v7H0v8.87H5.43Z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E"
        />
      </StrapiLink>
      <StrapiLink
        target="_blank"
        rel="noopener"
        className="icon"
        data={{
          ExternalUrl: 'https://www.instagram.com/roomstogo/',
          id: 'instagram-icon',
        }}
        trackingData={{
          category: 'footer',
          action: 'social click',
          label: 'instagram',
        }}
      >
        <img
          alt="Instagram (opens in new window)"
          src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2047.04%2047.04%22%20fill%3D%22%23FFFFFF%22%3E%3Cg%20id%3D%22Layer%5f2%22%20data-name%3D%22Layer%202%22%3E%3Cg%20id%3D%22Objects%22%3E%3Cpath%20d%3D%22M23.52%2C4.24c6.28%2C0%2C7%2C0%2C9.5.13a13.2%2C13.2%2C0%2C0%2C1%2C4.37.81A7.43%2C7.43%2C0%2C0%2C1%2C40.1%2C6.94a7.28%2C7.28%2C0%2C0%2C1%2C1.75%2C2.71A12.68%2C12.68%2C0%2C0%2C1%2C42.66%2C14c.12%2C2.48.14%2C3.22.14%2C9.5s0%2C7-.14%2C9.5a12.68%2C12.68%2C0%2C0%2C1-.81%2C4.37%2C7.67%2C7.67%2C0%2C0%2C1-4.46%2C4.46%2C12.68%2C12.68%2C0%2C0%2C1-4.37.81c-2.48.12-3.22.14-9.5.14s-7%2C0-9.5-.14a12.68%2C12.68%2C0%2C0%2C1-4.37-.81A7.28%2C7.28%2C0%2C0%2C1%2C6.94%2C40.1a7.43%2C7.43%2C0%2C0%2C1-1.76-2.71A13.2%2C13.2%2C0%2C0%2C1%2C4.37%2C33c-.11-2.48-.13-3.22-.13-9.5s0-7%2C.13-9.5a13.2%2C13.2%2C0%2C0%2C1%2C.81-4.37A7.77%2C7.77%2C0%2C0%2C1%2C9.65%2C5.18%2C13.2%2C13.2%2C0%2C0%2C1%2C14%2C4.37c2.48-.11%2C3.22-.13%2C9.5-.13m0-4.24c-6.39%2C0-7.19%2C0-9.7.14A17.51%2C17.51%2C0%2C0%2C0%2C8.11%2C1.23%2C11.69%2C11.69%2C0%2C0%2C0%2C4%2C4%2C11.69%2C11.69%2C0%2C0%2C0%2C1.23%2C8.11%2C17.51%2C17.51%2C0%2C0%2C0%2C.14%2C13.82C0%2C16.33%2C0%2C17.13%2C0%2C23.52s0%2C7.19.14%2C9.7a17.51%2C17.51%2C0%2C0%2C0%2C1.09%2C5.71A11.69%2C11.69%2C0%2C0%2C0%2C4%2C43.09%2C11.53%2C11.53%2C0%2C0%2C0%2C8.11%2C45.8a17.22%2C17.22%2C0%2C0%2C0%2C5.71%2C1.1c2.51.11%2C3.31.14%2C9.7.14s7.19%2C0%2C9.7-.14a17.22%2C17.22%2C0%2C0%2C0%2C5.71-1.1%2C12%2C12%2C0%2C0%2C0%2C6.87-6.87%2C17.22%2C17.22%2C0%2C0%2C0%2C1.1-5.71c.11-2.51.14-3.31.14-9.7s0-7.19-.14-9.7a17.22%2C17.22%2C0%2C0%2C0-1.1-5.71A11.53%2C11.53%2C0%2C0%2C0%2C43.09%2C4a11.69%2C11.69%2C0%2C0%2C0-4.16-2.72A17.51%2C17.51%2C0%2C0%2C0%2C33.22.14C30.71%2C0%2C29.91%2C0%2C23.52%2C0%22%2F%3E%3Cpath%20d%3D%22M23.52%2C11.44A12.08%2C12.08%2C0%2C1%2C0%2C35.6%2C23.52%2C12.08%2C12.08%2C0%2C0%2C0%2C23.52%2C11.44m0%2C19.92a7.84%2C7.84%2C0%2C1%2C1%2C7.84-7.84%2C7.84%2C7.84%2C0%2C0%2C1-7.84%2C7.84%22%2F%3E%3Cpath%20d%3D%22M38.9%2C11a2.83%2C2.83%2C0%2C1%2C1-2.83-2.82A2.83%2C2.83%2C0%2C0%2C1%2C38.9%2C11%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E"
        />
      </StrapiLink>
      <StrapiLink
        className="icon pin"
        rel="noopener"
        target="_blank"
        data={{
          ExternalUrl: 'https://www.pinterest.com/roomstogo/',
          id: 'pintrest-icon',
        }}
        trackingData={{
          category: 'footer',
          action: 'social click',
          label: 'pintrest',
        }}
      >
        <img
          alt="Pintrest (opens in new window)"
          src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2039.44%2050.95%22%20fill%3D%22%23FFFFFF%22%3E%3Cg%20id%3D%22Layer%5f2%22%20data-name%3D%22Layer%202%22%3E%3Cg%20id%3D%22Objects%22%3E%3Cpath%20d%3D%22M6%2C29.46a1%2C1%2C0%2C0%2C0%2C1.47-.73c.13-.51.45-1.81.6-2.35a1.42%2C1.42%2C0%2C0%2C0-.43-1.63A8.48%2C8.48%2C0%2C0%2C1%2C5.7%2C19c0-7.4%2C5.54-14%2C14.41-14C28%2C5%2C32.29%2C9.79%2C32.29%2C16.21c0%2C8.44-3.74%2C15.56-9.28%2C15.56a4.53%2C4.53%2C0%2C0%2C1-4.62-5.64C19.27%2C22.42%2C21%2C18.42%2C21%2C15.75c0-2.4-1.28-4.4-3.94-4.4-3.13%2C0-5.65%2C3.24-5.65%2C7.58a11.2%2C11.2%2C0%2C0%2C0%2C.94%2C4.63L8.55%2C39.5C7.43%2C44.24%2C8.38%2C50%2C8.47%2C50.62a.39.39%2C0%2C0%2C0%2C.69.17c.29-.37%2C4-5%2C5.28-9.57.36-1.31%2C2.06-8%2C2.06-8%2C1%2C1.94%2C4%2C3.65%2C7.15%2C3.65%2C9.41%2C0%2C15.79-8.58%2C15.79-20.06C39.44%2C8.08%2C32.09%2C0%2C20.91%2C0%2C7%2C0%2C0%2C10%2C0%2C18.28%2C0%2C23.31%2C1.91%2C27.79%2C6%2C29.46Z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E"
        />
      </StrapiLink>
      <StrapiLink
        target="_blank"
        rel="noopener"
        className="icon"
        data={{
          ExternalUrl: 'https://x.com/RoomsToGo/',
          id: 'x-icon',
        }}
        trackingData={{
          category: 'footer',
          action: 'social click',
          label: 'x',
        }}
      >
        <img
          alt="X (opens in new window)"
          src="data:image/svg+xml,%3Csvg%20width%3D%221200%22%20height%3D%221227%22%20viewBox%3D%220%200%201200%201227%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M714.163%20519.284L1160.89%200H1055.03L667.137%20450.887L357.328%200H0L468.492%20681.821L0%201226.37H105.866L515.491%20750.218L842.672%201226.37H1200L714.137%20519.284H714.163ZM569.165%20687.828L521.697%20619.934L144.011%2079.6944H306.615L611.412%20515.685L658.88%20583.579L1055.08%201150.3H892.476L569.165%20687.854V687.828Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E
"
        />
      </StrapiLink>
      <StrapiLink
        target="_blank"
        rel="noopener"
        className="icon"
        data={{
          ExternalUrl: 'https://www.youtube.com/channel/UCd77CqGAnGsyDD-lFFkyrNw',
          id: 'youtube-icon',
        }}
        trackingData={{
          category: 'footer',
          action: 'social click',
          label: 'youtube',
        }}
      >
        <img
          alt="YouTube (opens in new window)"
          src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2044.38%2051.22%22%20fill%3D%22%23FFFFFF%22%3E%3Cg%20id%3D%22Layer%5f2%22%20data-name%3D%22Layer%202%22%3E%3Cg%20id%3D%22Objects%22%3E%3Cpath%20d%3D%22M28.67%2C20a4.3%2C4.3%2C0%2C0%2C0%2C3.14-1.83v1.62h2.71V5.19H31.81V16.25c-.33.42-1.07%2C1.09-1.6%2C1.09s-.72-.39-.72-1V5.18H26.78V17.37C26.78%2C18.81%2C27.22%2C20%2C28.67%2C20Z%22%2F%3E%3Cpath%20d%3D%22M16.61%2C16.13c0%2C2.57%2C1.34%2C3.9%2C4%2C3.9a3.71%2C3.71%2C0%2C0%2C0%2C3.9-3.9V9a3.8%2C3.8%2C0%2C0%2C0-3.9-3.91%2C3.72%2C3.72%2C0%2C0%2C0-4%2C3.91ZM19.4%2C9.22c0-.8.37-1.39%2C1.13-1.39s1.19.58%2C1.19%2C1.39V16c0%2C.79-.41%2C1.37-1.14%2C1.37A1.22%2C1.22%2C0%2C0%2C1%2C19.4%2C16Z%22%2F%3E%3Cpolygon%20points%3D%2210.14%2019.77%2013.2%2019.77%2013.2%2011.75%2016.75%200%2013.65%200%2011.69%207.9%209.58%200%206.51%200%2010.14%2011.75%2010.14%2019.77%22%2F%3E%3Cpath%20d%3D%22M38.17%2C23.08h-32A6.22%2C6.22%2C0%2C0%2C0%2C0%2C29.3V45a6.22%2C6.22%2C0%2C0%2C0%2C6.21%2C6.22h32A6.22%2C6.22%2C0%2C0%2C0%2C44.38%2C45V29.3A6.22%2C6.22%2C0%2C0%2C0%2C38.17%2C23.08ZM10.47%2C46.56H7.57V30.47h-3V27.74h8.92v2.73h-3Zm10.34%2C0H18.23V45a5.44%2C5.44%2C0%2C0%2C1-1.48%2C1.29c-1.39.8-3.3.78-3.3-2V32.68H16V43.32c0%2C.56.13.94.68.94s1.21-.65%2C1.52-1V32.68h2.58Zm9.94-2.87c0%2C1.71-.64%2C3.05-2.36%2C3.05a3%2C3%2C0%2C0%2C1-2.45-1.24v1.06H23.33V27.74h2.61V33.8a3.09%2C3.09%2C0%2C0%2C1%2C2.29-1.3c1.89%2C0%2C2.52%2C1.6%2C2.52%2C3.48ZM40.29%2C40H35.36v2.62c0%2C1%2C.08%2C1.94%2C1.12%2C1.94s1.16-.74%2C1.16-1.94v-1h2.65v1c0%2C2.67-1.15%2C4.29-3.87%2C4.29-2.46%2C0-3.72-1.8-3.72-4.29V36.41a3.81%2C3.81%2C0%2C0%2C1%2C3.92-4.08c2.48%2C0%2C3.67%2C1.57%2C3.67%2C4.08Z%22%2F%3E%3Cpath%20d%3D%22M36.51%2C34.76c-1%2C0-1.15.67-1.15%2C1.63v1.4h2.28v-1.4C37.64%2C35.45%2C37.44%2C34.76%2C36.51%2C34.76Z%22%2F%3E%3Cpath%20d%3D%22M26.47%2C34.84a2%2C2%2C0%2C0%2C0-.53.43v8.65a2.15%2C2.15%2C0%2C0%2C0%2C.61.49%2C1.1%2C1.1%2C0%2C0%2C0%2C1.32-.14%2C1.62%2C1.62%2C0%2C0%2C0%2C.22-1V36.14a1.78%2C1.78%2C0%2C0%2C0-.27-1.07A1.09%2C1.09%2C0%2C0%2C0%2C26.47%2C34.84Z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E"
        />
      </StrapiLink>
    </div>
  </div>
)

const CustomExpandIcon = () => (
  <>
    <Remove className="expandIconWrapper" />
    <Add className="collapsIconWrapper" />
  </>
)

const StyledAccordion = styled(props => <Accordion disableGutters elevation={0} square {...props} />)`
  &:before {
    opacity: 0;
  }

  padding: 16px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  background-color: transparent;
  color: white;

  @media only screen and (min-width: 1024px) {
    padding: 0;
    border-bottom: none;
  }

  .MuiAccordionSummary-root {
    min-height: auto;
  }

  &.Mui-disabled {
    background-color: transparent;

    .MuiAccordionSummary-root {
      opacity: 1;
    }
  }

  .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: none;
  }
`

const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0;

  .MuiAccordionSummary-content {
    min-height: 24px;
    text-transform: uppercase;
    font-size: 19px;
    line-height: initial;
    font-weight: 600;
    margin: 0;
  }

  .MuiAccordionSummary-expandIconWrapper {
    color: white;
  }

  .Mui-expanded .sub-title {
    display: none;
    visibility: hidden;
  }

  .Mui-expanded > .collapsIconWrapper,
  .expandIconWrapper {
    display: none;
  }

  .Mui-expanded > .expandIconWrapper {
    display: block;
  }
`

const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 0;
  line-height: initial;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;

  @media only screen and (min-width: 1024px) {
    gap: 10px;
    margin-top: 10px;
  }

  .MuiLink-underlineHover:hover {
    text-decoration: none;
  }
`

const OneTruseCookieConsentModal = styled('div')`
  display: flex;
  & button#ot-sdk-btn {
    border: inherit !important;
    word-wrap: inherit !important;
    padding: inherit !important;
    letter-spacing: inherit !important;
    &:hover {
      background-color: inherit !important;
      text-decoration: underline;
    }
  }
`
const FooterAccordion = ({ children, className, title }) => {
  const [expanded, setExpanded] = useState(false)
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'))
  const uniqueId = title.toLowerCase().replace(/\s/g, '')

  return (
    <StyledAccordion
      expanded={isDesktop ? true : expanded}
      onChange={() => setExpanded(prev => !prev)}
      disabled={isDesktop}
      className={className}
    >
      <StyledAccordionSummary
        id={`${uniqueId}-header`}
        aria-controls={`${uniqueId}-content`}
        expandIcon={!isDesktop ? <CustomExpandIcon /> : null}
      >
        <Typography variant="h2" component="h2" color="white">
          {title}
        </Typography>
      </StyledAccordionSummary>
      <StyledAccordionDetails>{children}</StyledAccordionDetails>
    </StyledAccordion>
  )
}

FooterAccordion.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  className: PropTypes.string,
}

const FooterLink = ({ data }) => (
  <StrapiLink
    className="footer__navigation__link"
    data={data}
    category="footer"
    action="link click"
    target={data.Target}
    label={data.DisplayText ? data.DisplayText : data.Title}
    noarialabel="true"
    trackingData={{
      category: 'footer',
      action: 'link click',
      label: data.Title,
    }}
  >
    {data.DisplayText ? data.DisplayText : data.Title}
    {data.Target !== null && <span className="hide508">(opens in new window)</span>}
  </StrapiLink>
)

FooterLink.propTypes = {
  data: PropTypes.any,
}

const FooterComponent = ({ checkout, activeMenu, data }) => {
  const { user } = useFirebaseContext()
  const { actions } = useModalsContext()
  const { generateTestId } = useTest()

  if (!data) return null

  return (
    <footer id="main-footer" data-testid={generateTestId('footer', 'main')}>
      {!checkout && (
        <div className="footer__container footer__main-grid" data-testid={generateTestId('footer', 'main-grid')}>
          <nav aria-label="Footer Links" role="navigation" tabIndex="-1" className="footer__navigation">
            <FooterAccordion className="footer__navigation__contact-wrapper" title="Contact Us">
              <div
                className="footer__navigation__contact"
                dangerouslySetInnerHTML={{
                  __html: data.Contact.data.childMarkdownRemark.html,
                }}
              />
            </FooterAccordion>

            <div className="footer__navigation__spacer" />

            <Masonry
              breakpointCols={{
                default: 3,
                1439: 2,
                1023: 1,
              }}
              className="footer__navigation__masonry"
              columnClassName="footer__navigation__masonry__column"
            >
              {data?.LinkLists?.map?.(({ LinkList }) => (
                <FooterAccordion
                  key={LinkList.id}
                  title={
                    LinkList.HeadingLink.Link.DisplayText
                      ? LinkList.HeadingLink.Link.DisplayText
                      : LinkList.HeadingLink.Link.Title
                  }
                >
                  {LinkList.Links.map(({ Link }) => {
                    if (isSynchronyApplyLink(Link?.ExternalUrl)) {
                      return (
                        <div key={Link.id} className="footer__navigation__link-wrapper">
                          <ApplyButton
                            url={
                              isSynchronyWithQueriesLink(Link?.ExternalUrl)
                                ? `${Link?.ExternalUrl.substring(Link?.ExternalUrl.indexOf('&'))}&modalapply=true`
                                : `&modalapply=true`
                            }
                            aria-label={Link?.Title}
                            category="footer"
                            action="link click"
                          >
                            {Link.DisplayText ? Link.DisplayText : Link.Title}
                          </ApplyButton>
                        </div>
                      )
                    }
                    return (
                      <div
                        key={Link.id}
                        className={`footer__navigation__link-wrapper${
                          activeMenu === LinkList.HeadingLink.Link.Title ? ' active' : ''
                        }`}
                      >
                        {Link.InternalUrl === '/account' ? (
                          <>
                            {user ? (
                              <FooterLink data={{ ...Link, DisplayText: 'My Account' }} />
                            ) : (
                              <button type="button" className="footer__navigation__link" onClick={actions.login}>
                                {Link.DisplayText ? Link.DisplayText : Link.Title}
                              </button>
                            )}
                          </>
                        ) : (
                          <FooterLink data={Link} />
                        )}
                      </div>
                    )
                  })}
                </FooterAccordion>
              ))}
              <MobileStoreDownloads />
            </Masonry>
          </nav>

          <div className="footer__social-section">
            <EmailSubscribeForm />
            <TopRatedRetailer />
            <SocialMedia />
          </div>
        </div>
      )}

      <div className="footer__full">
        <div className="footer__container footer__bottom-bar">
          <StrapiLink
            className="footer__bottom-bar__logo-link"
            data={{
              InternalUrl: '/',
              title: 'Rooms To Go',
            }}
            trackingData={{
              category: 'footer',
              action: 'click',
              label: 'logo',
            }}
          >
            <RTGLogo uniqueNameForId="footer" fillColor="#fff" />
          </StrapiLink>
          <div className="footer__bottom-bar__copyright" dangerouslySetInnerHTML={{ __html: data?.Copyright }} />
          <div className="footer__bottom-bar__links">
            <StrapiLink
              className="footer__bottom-bar__link"
              data={data?.PrivacyPolicy}
              category="footer"
              action="privacy click"
              label="privacy policy"
              title={null}
            />
            <span className="footer__bottom-bar__divider">|</span>
            <StrapiLink
              className="footer__bottom-bar__link"
              data={data?.TermsOfUse}
              category="footer"
              action="terms click"
              label="terms of use"
              title={null}
            />
            <span className="footer__bottom-bar__divider">|</span>
            <OneTruseCookieConsentModal>
              <button
                type="button"
                id="ot-sdk-btn"
                className="ot-sdk-show-settings footer__bottom-bar__link"
                noarialabel="true"
              >
                Cookie Settings
              </button>
            </OneTruseCookieConsentModal>
          </div>
        </div>
      </div>
    </footer>
  )
}

FooterComponent.propTypes = {
  activeMenu: PropTypes.any,
  checkout: PropTypes.any,
  data: PropTypes.any,
}

export default FooterComponent
